import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import type { Movimentacao } from '../../../models';
import { mesclarEquipamentosMovimentacao } from '../../../models';
import { useMovimentacoesExcluidasQuery } from '../../../hooks/data';
import {
  MOTIVO_EXCLUSAO_MOVIMENTACAO_LABELS,
  TIPO_FLUXO_LABELS,
  TIPO_EQUIPAMENTO_LABELS,
} from '../solicitacaoDetailsPage.definitions';

function paraDataBR(timestamp: Movimentacao['excludedAt']): string | null {
  if (!timestamp) return null;
  const data = 'toDate' in timestamp ? timestamp.toDate() : new Date(timestamp as unknown as string);
  return data.toLocaleDateString('pt-BR');
}

/**
 * Registro das Movimentações excluídas (ver Movimentacao.excluida) — recolhido por padrão,
 * só aparece se houver alguma. Existe pra exclusão não "sumir" sem rastro: quem abrir a
 * Solicitação depois vê o que tinha, por quê saiu, quem tirou e quando.
 */
export default function MovimentacoesExcluidasSection({ solicitacaoId }: { solicitacaoId: string }) {
  const { data: excluidas = [] } = useMovimentacoesExcluidasQuery(solicitacaoId);
  const [expandido, setExpandido] = useState(false);

  if (excluidas.length === 0) return null;

  return (
    <div className="rounded-md border border-dashed border-gray-300 p-3">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-2 text-sm text-gray-500"
        onClick={() => setExpandido((atual) => !atual)}
      >
        <span>Movimentações excluídas ({excluidas.length})</span>
        {expandido ? <ChevronUpIcon className="h-4 w-4" /> : <ChevronDownIcon className="h-4 w-4" />}
      </button>
      {expandido && (
        <ul className="mt-2 space-y-2">
          {excluidas.map((movimentacao) => {
            const equipamentos = mesclarEquipamentosMovimentacao(
              movimentacao.equipamentosIntake ?? [],
              movimentacao.equipamentosExecucao
            )
              .map((item) => (item.tipoEquipamento ? TIPO_EQUIPAMENTO_LABELS[item.tipoEquipamento] : 'a definir'))
              .join(' + ');
            const data = paraDataBR(movimentacao.excludedAt);
            return (
              <li key={movimentacao.id} className="text-sm text-gray-600">
                <p className="font-medium text-gray-700">
                  {TIPO_FLUXO_LABELS[movimentacao.tipoFluxo]} — {equipamentos || 'nenhum equipamento'}
                </p>
                <p>
                  Motivo:{' '}
                  {movimentacao.motivoExclusaoTipo
                    ? MOTIVO_EXCLUSAO_MOVIMENTACAO_LABELS[movimentacao.motivoExclusaoTipo]
                    : 'não informado'}
                  {movimentacao.motivoExclusao ? ` — ${movimentacao.motivoExclusao}` : ''}
                </p>
                {(movimentacao.excludedBy?.name || data) && (
                  <p className="text-xs text-gray-400">
                    Excluída{movimentacao.excludedBy?.name ? ` por ${movimentacao.excludedBy.name}` : ''}
                    {data ? ` em ${data}` : ''}
                  </p>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
